import React from 'react';
import PropTypes from 'prop-types';

const ShowPasswordIcon = ({ active = false, ...props }) => (
    active
        ? <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 3.873 3.457" height="13.065" width="14.639" { ...props }>
                <path d="M1.95.35C1.223.338.535.773.166 1.39c-.065.14-.211.287-.15.451.204.41.521.768.91 1.011.145.09.299.166.461.22.04.013.082.024.124.032.401.069.826.032 1.205-.12a2.6 2.6 0 00.965-.836c.075-.132.193-.261.193-.42-.065-.21-.196-.396-.33-.568a2.258 2.258 0 00-.56-.499A1.934 1.934 0 001.95.35zm-.046.526a.91.91 0 01.644.213c.006.005.01.013.016.018.348.327.345.936.001 1.264a.779.779 0 01-.29.2c-.21.056-.44.08-.653.026a.827.827 0 01-.28-.188 1.135 1.135 0 01-.2-.272c-.208-.403-.059-.964.358-1.168a1.09 1.09 0 01.404-.093zm.028.371a.46.46 0 00-.408.228c-.138.2-.114.508.07.665a.39.39 0 00.11.07.558.558 0 00.597-.114c.205-.182.179-.518-.01-.699a.438.438 0 00-.082-.063.477.477 0 00-.277-.087z" fill="currentColor"/>
                <path fill="none" stroke="#fff" strokeWidth=".661" strokeMiterlimit="10" d="M4.631-1.09l-5.08 5.406"/>
                <path fill="none" stroke="currentColor" strokeWidth=".265" strokeMiterlimit="10" d="M.442 3.366L3.52.09"/>
            </svg>
        : <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 3.873 3.457" height="13.066" width="14.639" { ...props }>
                <path d="M1.95.335C1.223.323.535.759.166 1.375c-.065.14-.211.287-.15.451.204.41.521.768.91 1.011.145.09.299.166.461.22.04.013.082.024.124.032.401.069.826.032 1.205-.12a2.6 2.6 0 00.965-.836c.075-.132.193-.261.193-.42-.065-.21-.196-.396-.33-.568a2.258 2.258 0 00-.56-.499A1.934 1.934 0 001.95.335zM1.905.86a.911.911 0 01.644.213c.006.005.01.013.016.018.348.327.345.936.001 1.264a.778.778 0 01-.29.2c-.21.056-.44.08-.653.026a.827.827 0 01-.28-.188 1.135 1.135 0 01-.2-.272c-.207-.403-.059-.964.358-1.168a1.09 1.09 0 01.404-.093zm.028.372a.46.46 0 00-.408.227c-.138.2-.114.508.07.665a.39.39 0 00.11.07.558.558 0 00.597-.114c.205-.182.179-.518-.01-.699a.438.438 0 00-.082-.063.477.477 0 00-.277-.086z" fill="currentColor"/>
            </svg>
);

ShowPasswordIcon.propTypes = {
    active: PropTypes.bool,
};

ShowPasswordIcon.defaultProps = {
    active: false
};

export default ShowPasswordIcon;



// WEBPACK FOOTER //
// ./src/components/icons/ShowPasswordIcon.js